const Aux = props => props.children;

export default Aux;


// WEBPACK FOOTER //
// ./src/hoc/Auxilliary.js